export const columns = [

  {
    id: "commodity_id",
    label: "نام کالا",
    minWidth: 120,
    align: "center",
  },
  {
    id: "minimum_price",
    label: "پایین ترین قیمت",
    minWidth: 120,
    align: "center",
  },
  {
    id: "maximum_price",
    label: "بالاترین قیمت",
    minWidth: 120,
    align: "center",
  },
  {
    id: "offer_base_price",
    label: "قیمت پایه",
    minWidth: 120,
    align: "center",
  },
  {
    id: "offer_volume",
    label: "حجم عرضه",
    minWidth: 120,
    align: "center",
  },
  {
    id: "",
    label: " ",
    minWidth: 120,
    align: "center",
  },

];
